import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "effects-gallery" }
const _hoisted_2 = { class: "effects-gallery__hot-tip" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "effects-gallery__item-shadow" }, null, -1)
const _hoisted_5 = { class: "effects-gallery__item-name" }

import { effectGroups, EffectGroup, AvailableEffect } from '@/static/effectName'
import SolidCheckCircle from '@/assets/SolidCheckCircle.svg'
import LockIcon from '@/assets/LockWithCircleIcon.svg'
import FireIcon from '@/assets/FireIcon.svg'
import UnionWithCircleIcon from '@/assets/UnionWithCircle.svg'
import PictureHelper from '@/components/effect/PictureHelper.vue'
import EffectControlsPanel from '@/components/effect/EffectControlsPanel.vue'
import { useProjectStore } from '@/store/project-store'
import useEffect from '@/composables/UseEffect'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EffectGallery',
  setup(__props) {

const projectStore = useProjectStore()

const selectedEffectGroup = ref<EffectGroup | null>(null)
const selectedEffect = ref<AvailableEffect | null>()
const { addEffect, removeEffect } = useEffect()

const onSelectEffect = (effect: AvailableEffect) => {
  if (effect !== selectedEffect.value) {
    selectedEffect.value = effect
    addEffect(effect)
  }
}

const maxEffects = 2

const isEffectGroupSelected = (effectGroup: EffectGroup) => effectGroup.effects.some(effect => projectStore.activeEffectStates.has(effect.groupName))

const clickEffectGroup = (effectGroup: EffectGroup) => {
  if (selectedEffectGroup.value?.name === effectGroup.name) {
    if (!projectStore.activeEffectStates.get(effectGroup.name)?.isLocked) {
      deselectEffectGroup(effectGroup)
    }
  } else {
    if (projectStore.activeEffectStates.get(effectGroup.name)) {
      selectEffectGroup(effectGroup)
    } else if (projectStore.countLockedEffect < maxEffects) {
      if (projectStore.activeEffectStates.size === maxEffects) {
        removeFirstUnlockedEffectGroup()
      }
      selectEffectGroup(effectGroup)
    }
  }
}

const removeFirstUnlockedEffectGroup = () => {
  const firstUnlockedEffect = [...projectStore.activeEffectStates.values()].find(effectState => !effectState.isLocked)
  if (firstUnlockedEffect) {
    removeEffect(firstUnlockedEffect.groupName)
  }
}

const selectEffectGroup = (effectGroup: EffectGroup) => {
  selectedEffectGroup.value = effectGroup
  onSelectEffect(effectGroup.effects.find(effect => projectStore.activeEffectStates.get(effect.groupName)?.name === effect.name) ?? effectGroup.effects[0])
}

const deselectEffectGroup = (effectGroup: EffectGroup) => {
  selectedEffectGroup.value = null
  selectedEffect.value = null
  const appliedEffectFromGroup = effectGroup.effects.find(effect => projectStore.activeEffectStates.has(effect.groupName))
  if (appliedEffectFromGroup) {
    removeEffect(appliedEffectFromGroup.groupName)
  }
}

const effectGroupHasLockedEffect = (effectGroup: EffectGroup) => {
  return effectGroup.effects.some(effect => projectStore.activeEffectStates.get(effect.groupName)?.isLocked)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(FireIcon)),
      _createTextVNode(" Hot Tip: You can add up to two effects")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(effectGroups), (effectGroup, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["effects-gallery__item", { 'effects-gallery__item--selected': isEffectGroupSelected(effectGroup) }]),
        onClick: _withModifiers(($event: any) => (clickEffectGroup(effectGroup)), ["self"])
      }, [
        (effectGroupHasLockedEffect(effectGroup))
          ? (_openBlock(), _createBlock(_unref(LockIcon), {
              key: 0,
              class: "effects-gallery__item-icon effects-gallery__item-icon--locked",
              onClick: ($event: any) => (_unref(projectStore).toggleLock(effectGroup.name))
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_unref(SolidCheckCircle), {
              key: 1,
              class: "effects-gallery__item-icon"
            })),
        _createVNode(_unref(UnionWithCircleIcon), { class: "effects-gallery__item-icon effects-gallery__item-icon--hover" }),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(effectGroup.name), 1),
        _createVNode(PictureHelper, {
          class: "effects-gallery__item-image",
          "image-name": effectGroup.effects[0].thumbnail,
          densities: ['1x','2x'],
          formats: ['webp', 'jpg']
        }, null, 8, ["image-name"])
      ], 10, _hoisted_3))
    }), 128)),
    _createVNode(_Transition, { name: "effects-gallery__expand" }, {
      default: _withCtx(() => [
        (selectedEffectGroup.value && selectedEffect.value)
          ? (_openBlock(), _createBlock(EffectControlsPanel, {
              key: 0,
              "effect-group": selectedEffectGroup.value,
              "selected-available-effect": selectedEffect.value,
              onSelectEffect: _cache[0] || (_cache[0] = (effect) => onSelectEffect(effect))
            }, null, 8, ["effect-group", "selected-available-effect"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})